export default __webpack_public_path__ + "static/media/tata-sky-logo.ffa03bc4.png";